<template>
  <form class="order">
    <div id="services" v-if="web">
      <div class="block">
        <div class="inner" style="position: relative; padding: 0">
          <selector prefix="brands/" :options="$parent.webs" v-model="web" :app="$parent.is_app"></selector>
        </div>
        <p>{{ $t('messages.order.web') }}</p>
      </div>

      <div class="block">
        <div class="inner" style="position: relative; padding: 0">
          <selector label="label" :options="$parent.services.filter(item => item.is_hide == 0 && item.is_hidden == 0 && item.web_id == web.id && !item.is_big)" v-model="service" :app="$parent.is_app"></selector>
        </div>

        <p>{{ $t('messages.order.service') }}</p>
      </div>

      <div class="clearfix visible-xs"></div>

      <div v-if="$parent.services.find(item => item.is_hide === service.id) || service.is_hide" class="block half sub-type">
        <div class="inner text-center" >
          <div class="btn-group btn-group-justified">
            <label class="btn btn-sm btn-main" :class="{ active: service.is_hide }" @click="click(service.is_hide ? service.id : $parent.services.find(item => item.is_hide === service.id).id)">
              {{ $t(web.id === 1 ? 'messages.order.live2' : 'messages.order.live') }}
            </label>
            <label class="btn btn-sm btn-main" :class="{ active: service.is_hide == 0 }" @click="click(service.is_hide ? service.is_hide : service.id)">
              {{ $t(web.id === 1 ? 'messages.order.robots2' : 'messages.order.robots') }}
            </label>
          </div>
        </div>
        <p>{{ $t('messages.order.type') }}</p>
      </div>

      <div class="clearfix visible-xs"></div>

      <number v-show="!service.is_package" ref="amount" name="amount" v-model.number="amount" :min="service.min" :max="service.max" :step="service.step" :label="$t('messages.order.amount')"></number>

      <div v-show="service.is_comments || service.is_hidden" class="block half comments">
        <div class="inner" style="position: relative; padding: 0px;">
          <selector label="label" :sub="true" :options="$parent.services.filter(item => item.web_id === web.id && item.is_hidden != 0 && item.is_subscribe == 0)" v-model="comments_type" :app="$parent.is_app"></selector>
        </div>

        <p>{{ $t('messages.order.type') }}</p>
      </div>

      <div v-if="service.is_hidden && service.name === 'Comments Your'">
        <div class="clearfix"></div>
        <div class="block comments">
          <div class="inner" style="height: auto !important;" :class="{ bad: comments_text.split('\n').filter(v => v.trim().length).length !== amount }">
            <lined-textarea
                :max="amount"
                :nowrap="true"
                :styles="{ height:  '140px', resize: 'vertical' }"
                v-model="comments_text"
            ></lined-textarea>
          </div>
          <p>{{ comments_text.split('\n').filter(v => v.trim().length).length !== amount ? $t('messages.order.comments_error', { number : amount }) :  $t('messages.order.comments_text') }}</p>
        </div>
      </div>

      <div class="clearfix visible-xs"></div>

      <div v-if="service.is_subscribe && [3, 9].includes(service.web_id)" class="block half">
        <div style="margin: 5px; height: 54px;">
          <label>
            <input type="text" value="20" min="1" max="100" step="1" v-model.number="news" style="width: 50px; border-radius: 5px;border: 1px solid rgba(173,216,230,0.44);text-align: center;font-size: 18px;"/>
          </label>

          <div class="clearfix"></div>

          <div><vue-slider ref="news" :show="true" v-bind="{ ...options, min: 1 }" v-model.number="news"></vue-slider></div>

          <div class="clearfix visible-xs"></div>
        </div>

        <p>{{ $t(['Likes(Subscribe)', 'Real Likes(Subscribe)'].includes(service.name) ? 'messages.order.subscribest' : 'messages.order.subscribest2', {amount: amount, news: news}) }}</p>
        <div class="clearfix"></div>
      </div>

      <div v-if="service.is_subscribe && ![3, 9].includes(service.web_id) && !(['Stories(Subscribe)', 'Likes Year', 'Real Likes Year'].includes(service.name))" class="block half">
        <div style="margin: 5px; height: 54px;">
          <div>
            <div class="pull-left">
              <label>
                <input type="text" value="0" min="0" max="100" step="1" v-model.number="old" style="width: 40px;height: 28px; border-radius: 5px;text-align: center;font-size: 18px;"/>
              </label>
            </div>
            <div class="pull-right">
              <label>
                <input type="text" value="20" min="0" max="100" step="1" v-model.number="news" style="width: 40px;height: 28px;border-radius: 5px;text-align: center;font-size: 18px;"/>
              </label>
            </div>
          </div>

          <div class="clearfix"></div>

          <div>
            <div style="padding-left: 0;" class="col-xs-6 col-sm-6"><vue-slider ref="old" :show="true" direction="rtl" v-bind="options" v-model.number="old"></vue-slider></div>
            <div style="padding-right: 0;" class="col-xs-6 col-sm-6"><vue-slider ref="news" :show="true" v-bind="options" v-model.number="news"></vue-slider></div>
          </div>

          <div class="clearfix visible-xs"></div>

        </div>
        <p>{{ $t(['Likes(Subscribe)', 'Real Likes(Subscribe)'].includes(service.name) ? 'messages.order.subscribe' : 'messages.order.subscribe2',  {amount: amount, old: old, news: news}) }}</p>
        <div class="clearfix"></div>
      </div>

      <div class="block half url-input">
        <div class="clearfix"></div>
        <div  class="inner" :class="{ bad: is_avatar || is_private || status === false, good: status === true }" style="transition: background 1s;">
          <div class="label-icon">
            <icon scale="1.9" v-show="is_loading" :spin="true" name="sync"></icon>
            <icon scale="1.9" v-show="!is_loading" :name="'brands/' + web.icon.replace('socicon-', '').replace('vkontakte', 'vk')"></icon>
          </div>
          <input type="text" name="url" v-model.trim="url" :placeholder="service.example" autocomplete="off"/>
        </div>
        <p>{{ statustext }}</p>
      </div>

      <div v-if="service.is_subscribe && !(['Video(Subscribe)', 'Real Video(Subscribe)', 'Likes Year', 'Real Likes Year'].includes(service.name))" class="comments-block">
        <div class="clearfix"></div>
        <div class="block" style="margin-bottom: 10px;">
          <div class="inner" style="height: auto; background: #e5e6ff;">
            {{ $t('messages.order.addblock') }}
            <span v-if="services.comments">
              <i @click="comments_show = !comments_show" :class="{ active: comments_show }"><icon scale="0.7" name="comment"></icon>&nbsp;{{ $t('messages.order.comments_need') }}</i>,
            </span>
            <span v-if="services.saves">
              <i @click="saves_show = !saves_show" :class="{ active: saves_show }"><icon scale="0.7" name="bookmark"></icon>&nbsp;{{ $t('messages.order.saves_need') }}</i>,
            </span>
            <span v-if="services.reach">
              <i @click="reach_show = !reach_show" :class="{ active: reach_show }"><icon scale="0.7" name="bullhorn"></icon>&nbsp;{{ $t('messages.order.reach_need') }}</i>,
            </span>
            <i @click="random_show = !random_show" :class="{ active: random_show }"><icon scale="0.7" name="dice-five"></icon>&nbsp;{{ $t('messages.order.random_need') }}</i>
          </div>
        </div>


        <div v-if="services.comments && comments_show">

          <number ref="comments" name="comments" :label="$t('messages.order.comments_info', { comments: comments })" :optional="true" v-model.number="comments" :min="services.comments.min" :max="services.comments.max" :step="services.comments.step"></number>

          <div class="block half comments">
            <div class="inner" style="position: relative; padding: 0px;">
              <selector label="label" :sub="true" :options="$parent.services.filter(item => item.web_id === web.id && item.is_hidden != 0 && item.is_subscribe == 0)" v-model="comments_type" :app="$parent.is_app"></selector>
            </div>

            <p>{{ $t('messages.order.type') }}</p>
          </div>

          <div v-if="comments_type.name === 'Comments Your'">
            <div class="clearfix"></div>
            <div class="block comments">
              <div class="inner" style="height: auto !important;" :class="{ bad: comments_text.split('\n').filter(v => v.trim().length).length !== comments }">
                <lined-textarea
                    :max="comments"
                    :nowrap="true"
                    :styles="{ height:  '140px', resize: 'vertical' }"
                    v-model="comments_text"
                ></lined-textarea>
              </div>
              <p>{{ comments_text.split('\n').filter(v => v.trim().length).length !== comments ? $t('messages.order.comments_error', { number : comments }) :  $t('messages.order.comments_text') }}</p>
            </div>
          </div>
        </div>

        <div v-if="services.saves && saves_show">
          <number ref="saves" name="saves" :label="$t('messages.order.saves_info')" :optional="true" v-model.number="saves" :min="services.saves.min" :max="services.saves.max" :step="services.saves.step"></number>
        </div>

        <div v-if="services.reach && reach_show">
          <number ref="reach" name="reach" :label="$t('messages.order.reach_info')" :optional="true" v-model.number="reach" :min="services.reach.min" :max="services.reach.max" :step="services.reach.step"></number>
        </div>

        <div v-if="random_show">
          <number v-tooltip.top="{content: $t('messages.order.random_tooltip'), classes: ['col-sm-3 random_tooltip'], trigger: 'hover click'}" v-show="service.is_package || service.is_subscribe" ref="random" name="random" :label="$t('messages.order.random')" :step="5" :min="0" :max="30" suffix="%" v-model.number="random"></number>
        </div>
      </div>

      <div class="block half url-input" v-if="service.id === 100">
        <div class="inner" style="transition: background 1s;" :class="{ bad: username.length < 3 }">
          <div class="label-icon">
            <icon name="user" scale="1.8"></icon>
          </div>
          <input type="text" name="username" v-model.trim="username" :placeholder="$t('messages.order.username')" autocomplete="off"/>
        </div>
        <p>{{ $t('messages.order.username') }}</p>
      </div>

      <div class="block half url-input" v-if="!$parent.auth">
        <div class="inner" :class="{ bad: !validEmail(email) && email.length > 5, good: validEmail(email) }" style="transition: background 1s;">
          <div class="label-icon">
            <icon name="mail" scale="1.8"/>
          </div>
          <input type="text" name="email" v-model.trim="email" :placeholder="$t('messages.order.email')" autocomplete="off"/>
        </div>
        <p>{{ $t('messages.order.email') }}</p>
      </div>

      <div v-show="service.alert" class="block half alert-block">
        <div class="alert alert-warning" role="alert" style="display: block; margin:5px; min-height: 54px; background: #dbeef4;">
          <h6 style="font-size: 12px; margin: -4px !important; color: #000;">{{ service.alert }}</h6>
        </div>
      </div>

      <div class="block half" :style="{ opacity: (is_submit ? 0.5 : 1) }" :class="{ 'col-sm-offset-6': !service.is_offset && $parent.auth }">
        <div class="arrow" @click="order">
          <span class="cost" :key="cost">{{ cost.toFixed(2) }}&nbsp;{{ $t('messages.currency') }}</span>
          <div class="cart">
              <icon v-if="is_submit" name="sync" :spin="true" scale="1.8" style="margin-top: 5px;"></icon>
              <icon v-else name="shop" scale="2"></icon>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import Number from './Number.vue';
import URI from 'urijs';
import LinedTextarea from './LinedTextarea.vue';
import Selector from './Selector.vue';
import Tooltip from "./Tooltip";
import vueSlider from 'vue-slider-component';

export default {
  name: 'Order',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Tooltip,
    Number,
    LinedTextarea,
    Selector,
    vueSlider
  },
  computed: {
    statustext: function () {
      if(this.is_loading)
      {
        return this.$t('messages.order.url_loading');
      }
      else
      {
        if(this.is_private === 1)
        {
          return this.$t('messages.order.private.label');
        }
        else if(this.is_private === 2)
        {
          return this.$t('messages.order.private.label2');
        }
        else if(this.is_private === 3)
        {
          return this.$t('messages.order.private.label3');
        }
        else
        {
          return this.status === true ? this.$t('messages.order.url_good') : this.service.text;
        }
      }
    },
  },
  created: function() {
    this.$nextTick(function () {
      if(window.location.hash.length)
      {
        if(window.location.hash.indexOf(~window.location.hash.indexOf('|') ? '|' : '/') !== -1)
        {
          let params = window.location.hash.replace('#', '').toLowerCase().split(~window.location.hash.indexOf('|') ? '|' : '/');

          if(params[1] === 'gift' && this.$parent.auth === false)
          {
            this.$parent.tab = 7;
            this.tab(1);
          }
          else
          {
            let web = this.$parent.webs.find(item => item.name.toLowerCase() === params[1]);

            if (typeof web !== 'undefined') {
              this.tab(web.id);

              if (typeof params[2] !== 'undefined') {
                let service = this.$parent.services.find(item => item.name.toLowerCase() === params[2] && item.web_id === web.id);

                if (typeof service !== 'undefined') {
                  this.click(service.id);
                }
              }
            } else {
              this.tab(1);
            }
          }
          //window.location.hash = '';
        }
        else if(window.location.hash.replace('#', '').length)
        {
          this.tab(1);
        }
      }
      else
      {
        this.tab(1);
      }
    });

    this.bigs = this.$parent.services.filter(item => item.is_big);

    //Aria-label fix
    //setTimeout(() => [...document.querySelectorAll('.vue-slider-dot')].map(i => i.setAttribute('aria-label', 'Slider')), 0)
  },
  data: function(){ return {
    url: '',
    formatted: '',
    email: '',
    username: '',
    status: null,
    previousCheck: null,
    is_avatar: 0,
    is_private: 0,
    is_loading: false,
    is_submit: false,
    web: 0,
    service: 0,
    old : 10,
    news : 10,
    days: 10,
    views: 1000,
    likes: 100,
    amount: 0,
    cost: 0,
    comments_show: false,
    random_show: false,
    saves_show: false,
    reach_show: false,
    saves: 0,
    reach: 0,
    comments: 0,
    comments_type: {},
    comments_text: '',
    services: {},
    bigs: {},
    random: 0,
    event: null,
    followers: false,
    options: {
      eventType: 'auto',
      width: 'auto',
      height: 8,
      dotSize: 32,
      value: 0,
      min: 0,
      max: 100,
      interval: 1,
      speed: 1,
      style: {
        "padding": "0px",
      },
      tooltip: "none",
      railStyle: {
        "backgroundColor": "rgb(219, 238, 244)",
      },
      processStyle: {
        "backgroundColor": "#9bc7de"
      },
      dotStyle: {
        "backgroundColor": "rgb(155, 199, 222)"
      },
    }
  }},
  watch: {
    web: function(value, prev) {
      if(value !== prev)
      {
        this.tab(value.id)
      }
    },
    service: function(value, prev) {
      if(value !== prev)
      {
        if(this.web.id === 3)
        {
          this.old = this.saves = this.reach = this.comments = 0;
        }

        if(['Stories(Subscribe)', 'Video(Subscribe)', 'Real Video(Subscribe)'].includes(this.service.name))
        {
          this.saves = this.reach = this.comments = 0;
        }

        this.comments_show = this.random_show = this.saves_show = false;

        if(this.amount < this.service.min)
        {
          this.amount = this.service.min;
        }

        if(this.amount > this.service.max)
        {
          this.amount = this.service.max;
        }

        if(this.service['is_comments'])
        {
          this.service = this.comments_type;
        }

        this.calc();
        this.check(this.url);
      }
    },
    url: function(value, old) {
      clearTimeout(this.event);
      this.status = this.is_avatar = this.is_private = null;

      if(old !== value)
      {
        var self = this;

        this.event = setTimeout(function () {
          self.check(value);
        }, 500);
      }
    },
    days: function () {
      this.calc();
    },
    old: function () {
      this.calc();
    },
    news: function () {
      this.calc();
    },
    comments: function () {
      this.calc();
    },
    saves: function () {
      this.calc();
    },
    reach: function () {
      this.calc();
    },
    amount: function () {
      this.calc();
    },
    views: function () {
      this.calc();
    },
    likes: function () {
      this.calc();
    },
    comments_type: function (service) {
      if(!(this.service['is_package'] || this.service['is_subscribe']) && service !== undefined)
      {
        this.service = service;
      }
    },
    comments_show: function (value) {
      if(value === false)
      {
        this.comments = 0;
      }
      else
      {
        this.comments = this.comments_type.min;
      }
    },
    random_show: function (value) {
      if(value === false)
      {
        this.random = 0;
      }
      else
      {
        this.random = 5;
      }
    },
    saves_show: function (value) {
      if(value === false)
      {
        this.saves = 0;
      }
      else
      {
        this.saves = 100;
      }
    },
    reach_show: function (value) {
      if(value === false)
      {
        this.reach = 0;
      }
      else
      {
        this.reach = this.services.reach.min;
      }
    },
    username: function () {
      this.username = this.username.replace('@', '');
    },
  },
  methods: {
    validEmail(email) {
      // eslint-disable-next-line no-useless-escape
      return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    },
    tab(id) {
      this.web = this.$parent.webs.find(item => item.id === id);

      if(typeof this.web == 'undefined')
      {
        this.web = this.$parent.webs[0];
      }

      this.$parent.web = this.web.id;

      this.services = {
        views: this.$parent.services.find(item => item.web_id === this.web.id && item.is_hidden && item.is_package && item.is_subscribe && !item.is_hide),
        views_real: this.$parent.services.find(item => item.web_id === this.web.id && item.is_hidden && item.is_package && item.is_subscribe && item.is_hide),
        comments: this.$parent.services.find(item => item.web_id === this.web.id && item.is_hidden && item.is_subscribe && item.name === 'Comments(Time Subscribe)'),
        saves: this.$parent.services.find(item => item.web_id === this.web.id && item.is_hidden && item.is_subscribe && item.name === 'Saves(Time Subscribe)'),
        reach: this.$parent.services.find(item => item.web_id === this.web.id && item.is_hidden && item.is_subscribe && item.name === 'Reach & Impressions(Time Subscribe)'),
      }

      this.comments_type = this.$parent.services.find(item => item.web_id === this.web.id && item.is_hidden != 0 && item.is_subscribe == 0)

      var first = this.$parent.services.find(item => item.web_id === this.web.id && item.is_hide === 0);

      this.service = first;
      this.url = '';
    },
    click(id) {
      var find = this.$parent.services.find(item => item.id === parseInt(id));

      if(find['is_comments'])
      {
        find = this.$parent.services.find(item => item.is_hidden && !item.is_package && !item.is_subscribe);
      }

      this.service = find;
    },
    calc() {
      var sum = 0;

      let big = this.bigs.find(item => item.name === this.service.name && item.web_id === this.service.web_id);
      let price = typeof big !== 'undefined' && this.amount >= big.min ? big.price : this.service.price;

      if(this.service['is_package'])
      {
        sum = this.days * (this.likes * price * 6 + this.views * (this.service['is_hide'] ? this.services.views_real.price : this.services.views.price) * 3 + this.comments * this.comments_type.price * 6 + this.saves * this.services.saves.price * 6);
      }
      else if(this.service['is_subscribe'] && !(['Likes Year', 'Real Likes Year'].includes(this.service.name)))
      {
        sum = this.amount * (this.old + this.news) * price
            + this.comments * (this.old + this.news) * (this.comments_type ? this.comments_type.price : 0)
            + this.saves * (this.old + this.news) * (this.services.saves ? this.services.saves.price : 0)
            + this.reach * (this.old + this.news) * (this.services.reach ? this.services.reach.price : 0);
      }
      else
      {
        sum = this.amount * price;
      }

      if(this.$parent.site === 'likemania.kz') {
        sum *= window.settings.c;
      }

      this.cost = sum;
    },
    success() {
      this.$swal({
        title: this.service.success_title.length ? this.service.success_title : this.$t('messages.order.subscribesuccess'),
        html: this.service.success_text.length ? this.service.success_text : (this.web.id == 1 ? this.$t('messages.order.instagramsuccess') : ''),
        icon: 'success',
      })
    },
    pay(id, type, price) {
      this.$parent.tab = 3;

      this.$nextTick(() => {
        this.$parent.$refs.PaymentModal.show();
        this.$parent.$refs.PaymentModal.order_id = id;
        this.$parent.$refs.PaymentModal.order_type = type;
        this.$parent.$refs.PaymentModal.value = Math.ceil(price);
      })
    },
    async register() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('login');

      this.$http.jsonp('register', {
        params: {
          email: this.email,
          lang: this.$parent.lang,
          token: token
        }
      })
          .then(function (response) {
            if (response.body.status) {
              window.localStorage.setItem('key', response.body.secret);
              this.$parent.init(true);
            } else {
              this.$swal({
                title: this.$t('messages.alerts.error'),
                text: response.body.error,
                icon: 'error',
              });
            }
          }, function () {
            this.$swal({
              title: this.$t('messages.alerts.error'),
              text: this.$t('messages.alerts.servererror'),
              icon: 'error',
            });
          });
    },
    async order() {
        if(this.is_submit) return;

        this.is_submit = true;

        if (this.random && this.service.min > (this.amount - this.amount / 100 * this.random)) {
            const need = parseInt(this.amount) + parseInt(this.amount / 100 * this.random * 2);
            this.$swal({
                text: this.$t('messages.order.random_message', {number: need}),
                title: this.$t('messages.alerts.error'),
                icon: 'error',
            });
        } else if (this.url.pathname().length <= 3) {
            this.$swal({
                text: this.service.text,
                title: this.$t('messages.alerts.error'),
                icon: 'error',
            });
        } else if ((URI(this.url).domain().length && URI(this.url).domain() !== URI(this.formatted).domain()) && this.web.id !== 10 || (this.url.indexOf('@', 1) !== -1 && this.web.id === 1)) {
            this.$swal({
                text: this.service.text,
                title: this.$t('messages.alerts.error'),
                icon: 'error',
            });
        } else if (this.service.id === 34 && this.followers !== false && this.followers < 100) {
            this.$swal({
                title: this.$t('messages.alerts.error'),
                text: this.$t('messages.order.followers_error'),
                icon: 'error',
            });
        } else if (this.status) {
            if (this.$parent.auth === false) {
                await this.register();
            } else if ((this.service.is_subscribe && this.service.web_id === 1 || this.service.is_package) && this.comments_text.split('\n').filter(element => element.trim().length).length !== this.comments && this.comments_type.id === 95) {
                this.$swal({
                    title: this.$t('messages.alerts.error'),
                    text: this.$t('messages.order.comments_error', {number: this.comments}),
                    icon: 'error',
                });
            } else if ((this.service.is_comments || this.service.is_hidden) && this.comments_text.split('\n').filter(element => element.trim().length).length !== this.amount && this.comments_type.id === 95) {
                this.$swal({
                    title: this.$t('messages.alerts.error'),
                    text: this.$t('messages.order.comments_error', {number: this.amount}),
                    icon: 'error',
                });
            } else {
                await this.submit();
            }
        } else {
            const html = '<div class="check-link"><a target="_blank" href="' + this.formatted + '">' + URI(this.formatted).pathname() + '</a></div>' + this.$t('messages.order.check');

            if (this.is_avatar) {
                const result = await this.$swal({
                    html: '<br/><p>' + this.$t('messages.order.avatar.text') + '</p>' + html,
                    title: this.$t('messages.order.avatar.title'),
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('messages.order.avatar.confirm'),
                    cancelButtonText: this.$t('messages.order.avatar.cancel'),
                });
                if (result.value) {
                    await this.submit();
                }
            } else if (this.is_private === 1 || this.is_private === 2) {
                const result = await this.$swal({
                    html: '<br/><p>' + (this.is_private === 1 ? this.$t('messages.order.private.text') : this.$t('messages.order.private.text2')) + '</p>' + html,
                    title: this.$t('messages.order.private.title'),
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('messages.order.private.confirm'),
                    cancelButtonText: this.$t('messages.order.private.cancel'),
                });
                if (result.value) {
                    this.check(this.url);
                }
            } else {
                const result = await this.$swal({
                    html: '<br/><p>' + this.$t('messages.order.error.text') + '</p>' + html,
                    title: this.$t('messages.order.error.title'),
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('messages.order.error.confirm'),
                    cancelButtonText: this.$t('messages.order.error.cancel'),
                });
                if (result.value) {
                    if (this.$parent.auth === false) {
                        await this.register();
                    } else {
                        await this.submit();
                    }
                }
            }
        }

        this.is_submit = false
    },
    async submit() {
        const big = this.bigs.find(item => item.name === this.service.name && item.web_id === this.service.web_id);
        const service_id = typeof big !== 'undefined' && this.amount >= big.min ? big.id : this.service.id;

        try {
            const data = {
              web_id: this.web.id,
              service_id,
              amount: this.amount,
              saves: this.saves,
              reach: this.reach,
              comments: this.comments,
              comments_type: this.comments_type ? this.comments_type.id : null,
              comments_text: this.comments_text,
              random: this.random,
              old: this.old,
              new: this.news,
              url: this.formatted,
              fakeurl: this.url,
              username: !this.service['is_subscribe'] ? this.username : undefined,
              key: this.$parent.key,
              lang: this.$parent.lang,
              force: 1,
              is_api: 0,
              is_app: this.$parent.is_app
            };

            let form = new FormData();

            for (let key in data) {
              form.append(key, data[key]);
            }

            const response = await this.$http.post(this.service['is_subscribe'] ? 'subscribe' : 'task', form);

            if (response.body.error !== undefined) {
                throw new Error(response.body.error);
            }

            this.url = '';

            if (response.body.not_payed === 1) {
                await this.pay(response.body.id, this.service['is_subscribe'] ? 'subscribe' : 'request', response.body.price);
            } else {
                Promise.all([
                    this.$parent.$refs.tasks.getPage(0),
                    this.$parent.updateBalance()
                ]);

                this.$swal({
                    title: this.service.success_title.length ? this.service.success_title : this.$t('messages.order.tasksuccess'),
                    html: this.service.success_text.length ? this.service.success_text : (this.web.id == 1 ? this.$t('messages.order.instagramsuccess') : ''),
                    icon: 'success'
                });
            }
        } catch (error) {
            this.$swal({
                title: error.message || this.$t('messages.alerts.error'),
                text: error.message ? '' : this.$t('messages.alerts.servererror'),
                icon: 'error'
            });
        }
    },
    check(url){
      if(url.length > 2)
      {
        this.formatted = this.format(this.web.name, this.service.name, url);

        if(URI(this.formatted).pathname().length > 2)
        {
          this.is_loading = true;
          this.checkURL(this.web.name, this.service.name, this.formatted);
        }
        else
        {
          this.status = null;
        }
      }
      else
      {
        this.status = null;
      }
    },
    checkURL(web, service, url){

      /*
            const servers = [
              'https://likemania.com/test2/?url=',
            ];
      */

      if(this.checkExp(web, service, url))
      {
        this.is_avatar = this.is_private = false;
        this.status = true;
        this.is_loading = false;

        /*
              let api_url = servers[Math.floor((Math.random() * servers.length))] + encodeURIComponent(url);

        this.$http.get(api_url, {
                  before(request) {
                    if (this.previousCheck) {
                      this.previousCheck.abort();
                    }
                    this.previousCheck = request;
                  }
                }).then(function(response)
                {
                  self.status = response.body.status.http_code === 200;

                  if(web === 'Instagram' && this.status)
                  {
                    // eslint-disable-next-line no-useless-escape
                    var json = response.body.contents.match(new RegExp('window._sharedData = (.+);<\/script>', 'g'));

                    if(json !== null)
                    {
                      // eslint-disable-next-line no-useless-escape
                      json = JSON.parse(json[0].replace('window._sharedData = ', '').replace(';<\/script>', ''));
                    }

                    if(json !== null && typeof json.entry_data !== 'undefined')
                    {
                      if(['Reach & Impressions', 'Saves', 'Video', 'Video Real', 'Likes', 'Real Likes', 'Comments Good', 'Comments Smile', 'Comments Commercial', 'Comments Your', 'Likes to comment'].includes(service) && typeof json.entry_data.PostPage !== 'undefined')
                      {
                        var user = json.entry_data.PostPage[0].graphql.shortcode_media.owner;
                      }
                      else if(typeof json.entry_data.ProfilePage !== 'undefined')
                      {
                        // eslint-disable-next-line no-redeclare
                        var user = json.entry_data.ProfilePage[0].graphql.user;
                      }

                      if(typeof user !== 'undefined')
                      {
                        if(['Reach & Impressions', 'Saves'].includes(service))
                        {
                          let type = json.entry_data.PostPage[0].graphql.shortcode_media.product_type;

                          if(typeof type !== 'undefined' && type === 'igtv')
                          {
                            self.is_private = 3;
                            self.status = false;
                          }
                        }
                        else if(user.is_private && this.service.id !== 90)
                        {
                          self.is_private = 1;
                          self.status = false;
                        }
                        else
                        {
                          var blob = null;
                          var xhr = new XMLHttpRequest();
                          xhr.open('GET', user.profile_pic_url, true);
                          xhr.responseType = 'blob';
                          xhr.onload = function()
                          {
                            blob = xhr.response;

                            if(blob.size === 17421)
                            {
                              self.is_avatar = true;
                              self.status = false;
                            }

                          }
                          xhr.send();
                        }
                      }
                    }
                    else
                    {
                      if(response.body.contents.indexOf('cx-PRIVATE-Page__main') !== -1)
                      {
                        self.is_private = 2;
                        self.status = false;
                      }
                    }
                  }

                  if(web === 'Vkontakte' && this.status)
                  {
                    // eslint-disable-next-line no-useless-escape
                    let json = response.body.contents.match(new RegExp('(Участники|Подписчики)(.+?)<\/em>', ''));

                    if(json)
                    {
                      this.followers = parseInt(json[2].replace(/\D/g, ''));
                    }

                  }

                  if(web === 'Odnoklassniki' && self.status)
                  {
                    if(['Friends'].includes(service) && response.body.contents.length)
                    {
                      let id = Array.from(response.body.contents.matchAll(new RegExp('st.friendId=(\\d*)"', 'g')))[0][1];

                      if(id.length)
                      {
                        this.formatted = this.format(this.web.name, this.service.name, '/profile/' + id);
                      }
                    }
                  }

                  if(web === 'Tiktok' && self.status)
                  {
                    this.formatted = this.format(this.web.name, this.service.name, response.body.url);
                    // eslint-disable-next-line no-useless-escape
                    self.status = !!(['Likes', 'Views','Reposts', 'Real Likes', 'Real Views'].includes(service) ^ !(new RegExp("\/video\/", 'g').test(this.formatted)));
                  }

                  this.is_loading = false;
                }, function(response) {
                  this.is_avatar = this.is_private = false;
                  this.status = null;
                  this.is_loading = response.status === 0;
                });*/
      }
      else
      {
        this.is_avatar = this.is_private = false;
        this.status = false;
        this.is_loading = false;
      }
    },
    format(web, service, url) {

      if(!web) return '';

      return url;

      var parse;

      if((url.match(/https:/g)||[]).length > 1)
      {
        url = url.slice(0, url.indexOf("https:", 5));
      }

      if(web === 'Instagram')
      {
        url = url.replace('@', '');
        url = url.replace('/stories/', '/');
        //url = url.replace('/reel/', '/p/');

        if(url.indexOf('instagram.com') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain('instagram.com')
            .protocol('https')
            .query('')
            .subdomain('www')
            .hash('');

        if(parse.pathname().substr(-1) !== '/')
        {
          parse = parse.pathname(parse.pathname() + '/');
        }
      }

      if(web === 'Vkontakte')
      {
        if(url.indexOf('video/@') !== -1)
        {
          let match = url.match(/video([0-9_]+)/)

          if(match)
          {
            url = 'https://vk.com/' + match[0]
          }
        }

        url = url.replace('@', '');
        url = url.replace('?from=groups', '');

        if((url.indexOf('vk.com') !== -1 || url.indexOf('vkontakte.ru') !== -1 || url.indexOf('vk.ru') !== -1) && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        if(['Likes(Subscribe)', 'Real Likes(Subscribe)', 'Followers', 'Real Followers', 'Invites', 'Friends', 'Real Friends'].includes(service))
        {
          parse = URI(url)
              .normalize()
              .domain('vk.com')
              .protocol('https')
              .query('')
              .subdomain('')
              .hash('');
        }
        else
        {
          var json = url.match(new RegExp('z=photo(.+)', 'g'));

          if(json !== null)
          {
            url = json[0].split('%2F')[0].replace('z=', '').split('/')[0];
          }

          json = url.match(new RegExp('w=wall(.+)', 'g'));

          if(json !== null)
          {
            url = json[0].split('%2F')[0].replace('w=', '').split('/')[0];
          }

          parse = URI(url)
              .normalize()
              .domain('vk.com')
              .protocol('https')
              .subdomain('')
              .hash('');
        }

      }

      if(web === 'Twitter')
      {
        if(url.toLowerCase().indexOf('twitter.com') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain('twitter.com')
            .protocol('https')
            .subdomain('')
            .hash('');
      }

      if(web === 'Facebook')
      {
        url = url.replace('/pg/', '/');

        if(url.indexOf('facebook.com') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain(url.indexOf('fb.watch') !== -1 ? 'fb.watch' : 'facebook.com')
            .protocol('https')
            .subdomain('')
            .hash('');
      }

      if(web === 'Youtube')
      {
        if(url.indexOf('youtube.com') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        if(url.indexOf('/shorts/') !== -1)
        {
          url = 'https://www.youtube.com/watch?v=' + URI(url).path().replace(/(\/shorts\/|\/)/g, '');
        }

        parse = URI(url)
            .domain((url.indexOf('youtu.be') !== -1 && url.indexOf('youtu.be') !== (url.length - 8)) ? 'youtu.be' : 'youtube.com')
            .normalize()
            .protocol('https')
            .hash('');
      }

      if(web === 'Google')
      {
        if(url.indexOf('plus.google.com') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain('google.com')
            .subdomain('plus')
            .protocol('https')
            .hash('');
      }


      if(web === 'Odnoklassniki')
      {
        if(url.indexOf('ok.ru') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain('ok.ru')
            .protocol('https')
            .subdomain('')
            .hash('');
      }

      if(web === 'Tiktok')
      {
        if(url.indexOf('tiktok.com') === -1 && url.indexOf('@') === -1)
        {
          url = '@' + url;
        }

        if(url.indexOf('tiktok.com') !== -1 && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain('tiktok.com')
            .protocol('https')
            .hash('');

        if(!parse.subdomain().length)
        {
          parse = parse.subdomain('www');
        }
      }

      if(web === 'Telegram')
      {
        //url = url.toLowerCase();
        url = url.replace('@', '');
        url = url.replace('joinchat/', '');

        if((url.indexOf('t.me') !== -1 || url.indexOf('teleg.run') !== -1) && url.indexOf('http') === -1)
        {
          url = 'https://' + url;
        }

        parse = URI(url)
            .normalize()
            .domain('t.me')
            .protocol('https')
            .query('')
            .subdomain('')
            .hash('');
      }

      if(['Discord', 'Snapchat', 'Spotify','Linkedin','Twitch', 'Threads'].includes(web)) {
        parse = URI(url).normalize()
      }

      return parse.toString();
    },
    checkExp(web, service, url) {
      return true;
      var status = null;

      if(URI(this.url).domain().length && URI(this.url).domain() !== URI(this.formatted).domain() && web !== 'Telegram')
      {
        return false;
      }

      if(web === 'Instagram')
      {
        if(this.url.indexOf('@', 1) !== -1)
        {
          return false;
        }

        if(['Reach & Impressions', 'Saves', 'Real Saves', 'Video', 'Video Real', 'Likes', 'Real Likes', 'Comments Good', 'Comments Smile', 'Comments Commercial', 'Comments Your', 'Likes to comment'].includes(service))
        {
          if(new RegExp("/reel/(.+)", 'g').test(url) && ['Video', 'Video Real', 'Likes', 'Real Likes', 'Saves', 'Real Saves'].includes(service))
          {
            status = true;
          }
          else if(new RegExp("/tv/(.+)", 'g').test(url))
          {
            status = true;
          }
          else if(new RegExp("/p/(.+)", 'g').test(url))
          {
            let id = url.match(new RegExp("/p/(.+)"))[1].replace('/', '');

            if(id.length > 12)
            {
              status = false;
            }
            else
            {
              status = true;
            }
          }
          else
          {
            status = false;
          }
        }

        if(['Likes Year', 'Real Likes Year', 'Video(Subscribe)', 'Real Video(Subscribe)', 'Visits', 'Bot Followers', 'Real Followers', 'Likes(Subscribe)', 'Likes(Time Subscribe)', 'Real Likes(Subscribe)', 'Stories', 'Real Stories', 'Stories30', 'Auto Stories', 'Stories(Subscribe)'].includes(service))
        {
          if(new RegExp("/p/(.+)", 'g').test(url) || new RegExp("/tv/(.+)", 'g').test(url) || new RegExp("/reel/(.+)", 'g').test(url))
          {
            status = false;
          }
          else
          {
            status = true;
          }
        }
      }

      if(web === 'Twitter')
      {
        if(['Likes', 'Retweets','Favorites'].includes(service))
        {
          if(new RegExp("/status/(.+)", 'g').test(url))
          {
            status = true;
          }
          else
          {
            status = false;
          }
        }

        if(service === 'Followers')
        {
          if(new RegExp("/status/(.+)", 'g').test(url))
          {
            status = false;
          }
          else
          {
            status = true;
          }
        }
      }

      if(web === 'Vkontakte')
      {
        if(['Likes', 'Real Likes', 'Reposts', 'Video', 'Views'].includes(service))
        {
          if(new RegExp("photo(-|)(\\d+)", 'g').test(url) || new RegExp("wall(-|)(\\d+)", 'g').test(url) || new RegExp("video(-|)(\\d+)", 'g').test(url))
          {
            status = true;
          }
          else
          {
            status = false;
          }
        }

        if(['Followers', 'Real Followers', 'Likes(Subscribe)', 'Real Likes(Subscribe)', 'Invites', 'Friends', 'Real Friends'].includes(service))
        {
          if(new RegExp("photo(-|)(\\d+)", 'g').test(url) || new RegExp("wall(-|)(\\d+)", 'g').test(url) || new RegExp("video(-|)(\\d+)", 'g').test(url))
          {
            status = false;
          }
          else
          {
            status = true;
          }
        }
      }

      if(web === 'Facebook')
      {
        let isGroup = new RegExp("/groups/", 'g').test(url);

        status = !((isGroup && ['Likes on page', 'Friends'].includes(service)) || (!isGroup && ['Join'].includes(service)));
      }

      if(web === 'Youtube')
      {
        status = true;
      }

      if(web === 'Google')
      {
        // eslint-disable-next-line no-useless-escape
        if(new RegExp("((http|https):\/\/)?(www[.])?plus\.google\.com\/.?\/?.?\/?([0-9]*).?\/", 'g').test(url))
        {
          status = true;
        }
        else
        {
          status = false;
        }
      }

      if(web === 'Odnoklassniki')
      {
        status = true;
      }

      if(web === 'Tiktok')
      {
        // eslint-disable-next-line no-useless-escape
        //status = ['Likes', 'Views'].includes(service) ^ !(new RegExp("\/video\/", 'g').test(url) || new RegExp("vm.", 'g').test(url));
        status = true;
      }

      if(web === 'Telegram')
      {
        status = !(URI(this.url).domain().length &&
            URI(this.url).domain() !== URI(this.formatted).domain() &&
            !['t.me', 'teleg.run'].includes(URI(this.url).domain()));
      }

      if(['Discord', 'Snapchat', 'Spotify','Linkedin','Twitch', 'Threads'].includes(web)) {
          status = true;
      }

      return status;
    },
  },
}
</script>

<style scoped>
.comments-link {

}

.comments-link .active {
  background: rgb(49, 121, 194);
}

.comments-link .squaredFour, .comments-link .label {
  float: left;
  top: auto;
  left: auto;
}

.comments-link .squaredFour {
  margin-right: 10px;
}

.comments-hr {
  margin: 0;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 22px;
  margin-bottom: -22px;
  border-top: 3px solid rgb(219, 238, 244);
}
.comments-block {
  margin-bottom: 0px;
  color: #485291;
}

.btn {
  transition: all 0.4s;
}

.comments-link-inner {
  width: 200px;

  cursor: pointer;
  transition: all 0.4s;
  background: rgb(219, 238, 244) none repeat scroll 0% 0%;
  color: rgb(0, 0, 0) !important;
  padding: 6px;
  text-decoration: none !important;
  border-radius: 5px !important;
  outline: none;
  line-height: 2.3em;

  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
}

.comments-block i {
  font-style: normal;
  cursor: pointer;
  border-bottom: dashed 1px #3a5a7a;
  white-space: nowrap;
}

.comments-block i.active, .comments-block i:hover {
  color: red;
  border-bottom: dashed 1px red;
  background: none;
  -webkit-box-shadow: none;
  box-shadow:none;
}

.fallback {
  width: 100%;
  height: 46px;
  position: absolute;
  z-index: 99999;
  opacity: 0;
}

</style>